import SearchIcon from "../../assets/icons/Search.svg";
import { useState } from 'react';

const SearchBar = ({ 
  placeholder = "Search...",
  showSearchButton = true,
  showClearButton = true,
}) => {
  const [searchText, setSearchText] = useState('');

  const handleClear = () => {
    setSearchText('');
  };

  return (
    <div className="w-full flex items-center gap-[10px] max-w-[90vw] sm:max-w-full">
      {/* Search Input */}
      <div className="relative flex-grow max-w-[27rem]">
        <input 
          type="text"
          placeholder={placeholder}
          value={searchText}
          onChange={(e) => setSearchText(e.target.value)}
          className="
            w-full
            h-[2.8125rem]
            pl-[2rem]
            pr-[1rem]
            rounded-md
            border border-gray-300
            text-sm
            focus:outline-none
          "
        />
        <span className="absolute left-3 top-1/2 -translate-y-1/2">
          <img src={SearchIcon} alt="Search icon" width={14} height={14} />
        </span>
      </div>

      <div className="flex items-center gap-[10px]">
        {showSearchButton && (
          <button className="
            bg-[#873FE2b0] 
            border border-[#873FE2] 
            text-white 
            w-[5.1875rem] 
            h-[2.8125rem] 
            rounded-md 
            text-xs
          ">
            SEARCH
          </button>
        )}

        {showClearButton && (
          <button 
            onClick={handleClear}
            className="
              bg-transparent 
              border border-[#873FE2] 
              text-[#873FE2] 
              w-[5.1875rem] 
              h-[2.8125rem] 
              rounded-md 
              text-xs 
              mr-[237px]
              custom-w-br-480:mr-10
              sm:mr-[237px]
            "
          >
            CLEAR
          </button>
        )}
      </div>
    </div>
  );
};

export default SearchBar;
